// extracted by mini-css-extract-plugin
export default {"slider":"slider__slider___2ju2O","slider-tooltip":"slider__slider-tooltip___2OmTC","markers":"slider__markers___39l6F","marker":"slider__marker___3bCqh"};